export const state = {
  // product: undefined,
  // products: []
  ecran: {},
  ecrans: [],
  pagination:''
}
